import { apiRoutes } from "@constants/api-routes";
import { handleRequest } from "@utils/http-util";
import { injectRpServiceId } from "@utils/parameter-injector";
import { RequestTypes } from "@enums/request-types";
import { VerificationServiceChangeRequestResponse } from "@idw-types/data/verification-service";

export const createVerificationServiceChangeRequestRequest = async (
    rpServiceId: string
): Promise<{ data: VerificationServiceChangeRequestResponse, error: any }> => {
    const route = injectRpServiceId(
        apiRoutes.serviceConfiguration.rpServiceConfig.changeRequest.rpService.createChangeRequest,
        rpServiceId
    );
    const { data, error } = await handleRequest(RequestTypes.POST, route);
    return { data, error };
};